import React from "react";

import FormField from "components/MeForm/FormField";
import { classNames, colors } from "tools/ui";
import { PlusCircleIcon, MinusCircleIcon } from "components/Icons";

const base =
  "rounded-none w-full border-t text-center border-b border-slate-300 py-2 px-3 text-gray-700 focus:outline-none focus:border focus:border-cyan-500 ";
const iconStyle = "w-7 h-7 text-stone-700";
const stBtn =
  "flex text-xl text-zinc-500 border-slate-300 border-[1px] px-3 py-1 focus:outline-none";
const leftBtn = "rounded-l-md";
const rightBtn = "rounded-r-md";

function IntegerField(props) {
  const { field, value, onChange } = props;
  const { name, readOnly } = field;
  let btnBgColor = "bg-amber-100 active:bg-amber-200";
  if (readOnly) {
    btnBgColor = "bg-gray-300";
  }

  function handleChange(rawValue) {
    let _value = rawValue.toString().replace(/\./g, "");
    if (isNaN(_value)) {
      return;
    }
    onChange(Number(_value));
  }

  let _color = "bg-white";
  if (field.color === "gray") {
    _color = "bg-gray-100";
  }
  if (readOnly) {
    _color = colors.readOnly;
  }

  const changeValue = (e, sign) => {
    e.preventDefault();
    if (readOnly) return;
    const current = Number(value) || 0;
    const next = sign === "+" ? current + 1 : Math.max(0, current - 1);
    onChange(next);
  };

  const btnMinus = (
    <button
      className={classNames(stBtn, leftBtn, btnBgColor)}
      onClick={(e) => changeValue(e, "-")}
    >
      <MinusCircleIcon className="font-extrabold  my-auto fill-current" />
    </button>
  );

  const btnPlus = (
    <button
      className={classNames(stBtn, rightBtn, btnBgColor)}
      onClick={(e) => changeValue(e, "+")}
    >
      <PlusCircleIcon className="font-extrabold my-auto fill-current" />
    </button>
  );

  const _value = Number(value) || 0;
  return (
    <FormField {...field}>
      <div className="flex items-stretch w-full h-10">
        {btnMinus}
        <input
          id={name}
          name={name}
          min="0"
          type="number"
          value={_value}
          className={classNames(base, _color)}
          onChange={(e) => handleChange(e.target.value)}
          readOnly={readOnly}
        />
        {btnPlus}
      </div>
    </FormField>
  );
}

export default IntegerField;
